import { useCallback, useEffect, useState } from 'react'
/* returns state: loading | success | empty | error */
export default function useAsync(fn, deps = []) {
  const [s, setS] = useState({ state: 'loading', data: null })
  const run = useCallback(() => {
    setS({ state: 'loading', data: null })
    fn().then(d => setS({ state: (Array.isArray(d) ? d.length : d) ? 'success' : 'empty', data: d }))
      .catch(() => setS({ state: 'error', data: null }))
  }, deps) // eslint-disable-line
  useEffect(run, [run])
  return { ...s, reload: run }
}
